import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import performance from "../../../../../assets/performance.png";
import appUrl from "../../../../config/appUrl";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const BRAND = "#4475a5";
const ACCENT = "#f59e0b";

const ParkingCollectionChart = ({ toDate, fromDate, siteId, gtagOnly, qrOnly }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!fromDate || !toDate) return;

    const fetchData = async () => {
      try {
        const res = await axios.get(`${appUrl.BASE_URL}ParkingHistory/boothState`, {
          params: {
            fromDate,
            toDate,
            ...(siteId ? { site: siteId } : {}),
            ...(gtagOnly !== undefined && qrOnly !== undefined
              ? { GTagData: gtagOnly, QRData: qrOnly }
              : {}),
          },
        });

        const { checkin, checkout } = res.data.data;

        const booths = [
          ...new Set([
            ...checkin.map((c) => c.booth),
            ...checkout.map((c) => c.booth),
          ]),
        ];

        const checkinData = booths.map(
          (booth) => checkin.find((c) => c.booth === booth)?.totFee || 0,
        );
        const checkoutData = booths.map(
          (booth) => checkout.find((c) => c.booth === booth)?.totFee || 0,
        );

        setChartData({
          labels: booths,
          datasets: [
            {
              label: "Check-in",
              data: checkinData,
              backgroundColor: BRAND,
              borderRadius: 8,
              barThickness: 22,
            },
            {
              label: "Check-out",
              data: checkoutData,
              backgroundColor: ACCENT,
              borderRadius: 8,
              barThickness: 22,
            },
          ],
        });
      } catch (err) {
        console.error("API Error:", err);
      }
    };

    fetchData();
  }, [fromDate, toDate, siteId, gtagOnly, qrOnly]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          boxWidth: 12,
          padding: 16,
          usePointStyle: true,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value.toLocaleString("en-US", { maximumFractionDigits: 0 });
          },
        },
        grid: {
          color: "#eef2f6",
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div className="dashboard-chart-inner">
      <div className="dashboard-chart-head">
        <h5>Site stats</h5>
      </div>
      <div className="dashboard-chart-canvas dashboard-chart-canvas--short">
        {chartData && chartData.labels ? (
          <Bar data={chartData} options={options} />
        ) : (
          <p className="text-600 m-0">Loading chart…</p>
        )}
      </div>
    </div>
  );
};

export default ParkingCollectionChart;
